import { apiGet, apiPost, getHostApi, isObjectPathDefined } from "./apiWrapper";
import { errorType } from './appContextStore';
import { isNullOrUndefined } from "./storeFunctions";

const STARTED = "STARTED";
const STARTED_MARKET = "STARTED_MARKET";

const SUCCESS = "SUCCESS";
const SUCCESS_MARKET = "SUCCESS_MARKET";
const RESET = "RESET";
const ADD = "ADD";

const initialState = {
    lastSearchedSubjects: [],
    lastSearchedSubjectsMarket: [null, [], [], []],
    isLoading: false,
    dataLoaded: false,
    isLoadingMarket: [null, false, false, false],
    dataLoadedMarket: [null, false, false, false],
    error: null
};

export const lastSubjectActions = {
    getSubjects: () => async (dispatch, getState) => getLastSearchedSubjects(dispatch, getState),
    getSubjectsMarket: (market) => async (dispatch, getState) => getLastSearchedSubjectsMarket(dispatch, getState, market),
    resetSubjects: () => async (dispatch) => dispatch({ type: RESET }),
    pushSubject: (data) => async (dispatch) => dispatch({ type: ADD, data })
}
// store reducer
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case STARTED:
            return { ...state, isLoading: true };
        case STARTED_MARKET: {
            var isLoadingMarket = [...state.isLoadingMarket];
            isLoadingMarket[action.market] = true;
            return { ...state, isLoadingMarket };
        }
        case SUCCESS:
            return { ...state, isLoading: false, dataLoaded: true, lastSearchedSubjects: action.subjects };
        case SUCCESS_MARKET: {
            var isLoadingMarket2 = [...state.isLoadingMarket];
            isLoadingMarket2[action.market] = false;
            var dataLoadedMarket = [...state.dataLoadedMarket];
            dataLoadedMarket[action.market] = true;
            var lastSearchedSubjectsMarket = [...state.lastSearchedSubjectsMarket];
            lastSearchedSubjectsMarket[action.market] = action.subjects;
            return { ...state, isLoadingMarket: isLoadingMarket2, dataLoadedMarket, lastSearchedSubjectsMarket };
        }
        case RESET:
            return { ...state, isLoading: false, isLoadingMarket: [...initialState.isLoadingMarket], lastSearchedSubjects: [], lastSearchedSubjectsMarket: [...initialState.lastSearchedSubjectsMarket], dataLoaded: false, dataLoadedMarket: [...initialState.dataLoadedMarket], error: action.error };
        case ADD:
            const copied = Object.assign([], state.lastSearchedSubjects.filter(s => s.entityId !== action.data.entityId));
            copied.unshift(action.data);

            if (action.data.reports.primaryAttr === 1 || action.data.reports.primaryAttr === 2) {
                var lastSearchedSubjectsMarket2 = [...state.lastSearchedSubjectsMarket];
                if (!isNullOrUndefined(lastSearchedSubjectsMarket2[action.data.reports.primaryAttr]) && lastSearchedSubjectsMarket2[action.data.reports.primaryAttr].length > 0) {
                    const copiedM = Object.assign([], lastSearchedSubjectsMarket2[action.data.reports.primaryAttr].filter(s => s.entityId !== action.data.entityId));
                    copiedM.unshift(action.data);
                    lastSearchedSubjectsMarket2[action.data.reports.primaryAttr] = [...copiedM];
                }
                if (!isNullOrUndefined(lastSearchedSubjectsMarket2[3]) && lastSearchedSubjectsMarket2[3].length > 0) {
                    const copiedM = Object.assign([], lastSearchedSubjectsMarket2[3].filter(s => s.entityId !== action.data.entityId));
                    copiedM.unshift(action.data);
                    lastSearchedSubjectsMarket2[3] = [...copiedM];
                }
                return { ...state, lastSearchedSubjects: copied, lastSearchedSubjectsMarket: lastSearchedSubjectsMarket2 };
            }

            return { ...state, lastSearchedSubjects: copied };
        default:
            return state;
    }
}
function getLastSearchedSubjects(dispatch, getState) {
    dispatch({ type: STARTED });
    apiGet(`${getHostApi()}/api/account/last-searched-subjects`, null,
        (s) => {
            dispatch({ type: SUCCESS, subjects: isObjectPathDefined(s, 'data.subjects') ? s.data.subjects : [] });
        },
        (f) => {
            dispatch({ type: RESET, error: (((f || {}).data || {}).error || {}).message });
            dispatch({ type: errorType, message: null });
        });
}


function getLastSearchedSubjectsMarket(dispatch, getState, market) {
    dispatch({
        type: STARTED_MARKET, market
    });

    var marketAttributes = market === 3 ? [1, 2] : [market];
    apiPost(`${getHostApi()}/api/account/last-searched-subjects-market`, null, marketAttributes,
        (s) => {
            dispatch({ type: SUCCESS_MARKET, subjects: isObjectPathDefined(s, 'data.subjects') ? s.data.subjects : [], market });
        },
        (f) => {
            dispatch({ type: RESET, error: (((f || {}).data || {}).error || {}).message });
            dispatch({ type: errorType, message: null });
        });
}